import { render, staticRenderFns } from "./ChartMessagesCountry.vue?vue&type=template&id=64980f3b"
import script from "./ChartMessagesCountry.vue?vue&type=script&lang=js"
export * from "./ChartMessagesCountry.vue?vue&type=script&lang=js"
import style0 from "./ChartMessagesCountry.vue?vue&type=style&index=0&id=64980f3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports